import type {ReactNode} from 'react';
import {Box} from '@mantine/core';

export interface FullBleedProps {
  children: ReactNode;
  /** `full` = all edges + viewport-height flex column; `frame` = top/left/right only. */
  variant: 'full' | 'frame';
}

/**
 * Cancels AppShell.Main's edge padding (via its own `--app-shell-padding` var,
 * so it tracks the shell's padding prop) for full-bleed page surfaces.
 * @registry Full-bleed wrapper cancelling AppShell.Main's edge padding, full or top/left/right only.
 */
export const FullBleed = ({children, variant}: FullBleedProps) => {
  const style =
    variant === 'full'
      ? ({
          display: 'flex',
          flexDirection: 'column',
          height: '100dvh',
          minHeight: 0,
          margin: 'calc(-1 * var(--app-shell-padding))',
          overflow: 'hidden',
          overscrollBehaviorY: 'contain',
        } as const)
      : ({
          marginTop: 'calc(-1 * var(--app-shell-padding))',
          marginLeft: 'calc(-1 * var(--app-shell-padding))',
          marginRight: 'calc(-1 * var(--app-shell-padding))',
        } as const);

  return <Box style={style}>{children}</Box>;
};
